module.exports = __webpack_public_path__ + "static/media/sf_2500.42a6b5600059b185f9e0a74204c9793a.png";